import React, { Component } from 'react';
import {createHashHistory} from 'history';
import createBrowserHistory from 'history/lib/createBrowserHistory'
import { Router, IndexRoute, Route } from 'react-router';

import Login from './screens/Login';
import Support from './screens/Support';

import ChapterList from './screens/ChapterList';
import SubChapterList from './screens/SubChapterList';

import AssessmentChapters from './screens/AssessmentChapters';
import AssessmentDifficulty from './screens/AssessmentDifficulty';

import Signup from './screens/signup/SignupStart';
import SignupProfile from './screens/signup/SignupProfile';
import SignupSchool from './screens/signup/SignupSchool';
import SignupBook from './screens/signup/SignupBook';
import SignupDone from './screens/signup/SignupDone';

import Profile from './screens/profile/Profile';
import ProfileSchool from './screens/profile/ProfileSchool';
import ProfilePassword from './screens/profile/ProfilePassword';
import ProfileNotifications from './screens/profile/ProfileNotifications';
import ProfilePayment from './screens/profile/ProfilePayment';
import ProfilePaymentCard from './screens/profile/ProfilePaymentCard';
import ProfilePaymentCancel from './screens/profile/ProfilePaymentCancel';
import ProfileBook from './screens/profile/ProfileBook';

import App from './App';
import Dashboard from './screens/Dashboard';
import Book from './screens/Book';
import BookRouter from './screens/BookRouter';
import BookList from './screens/BookList';

import Lesson from './screens/Lesson';
import LessonChapters from './screens/LessonChapters';
import LessonSubChapters from './screens/LessonSubChapters';

import Exercise from './screens/Exercise';
import UUID from 'node-uuid';
import assign from 'object-assign';
import {firebaseRoot} from './utils/firebase-utils'
import Page from './mocks/Page';
import FileUpload from './mocks/FileUpload';
import {isCordovaApp} from './utils/Browser';

import AdminApp from './admin/App';
import AdminRoles from './admin/screens/Roles';
import AdminVideoUpload from './admin/screens/VideoUpload';
import AdminDashboard from './admin/screens/Dashboard';
import AdminBook from './admin/screens/Book';
import AdminExerciseList from './admin/screens/ExerciseList';
import Import from './admin/screens/Import';

import UserAuth from './UserAuth';
import UserRef from './UserRef';

const NoMatch = () => <div>Not found</div>;


function createWrappedHistory(history) {
    let goingBack = false;

    return assign({}, history, {
        isGoingBack() {
            return goingBack;
        },

        goBack() {
            goingBack = true;
            history.goBack();
        },

        goForward() {
            goingBack = false;
            history.goForward();
        },

        go(n) {
            goingBack = n < 0;
            history.go(n);
        },

        push(location) {
            goingBack = false;
            history.push(location);
        },

        replace(location) {
            goingBack = false;
            history.replace(location);
        },

        transitionTo(nextLocation) {
            goingBack = false;
            history.transitionTo(nextLocation);
        }
    });
}

function directToUniqueImportId(nextState, replaceState) {
    replaceState({}, `/admin/import/${UUID.v1()}`)
}

const Routes = React.createClass({
    logout() {
        firebaseRoot.unauth();
        window.location.href = "/";
    },

    render() {
        const history = createWrappedHistory(isCordovaApp() ? createHashHistory() : createBrowserHistory());

        return (
            <UserRef>
                <Router history={history}>
                    <Route path="/admin" component={AdminApp}>
                        <IndexRoute component={AdminDashboard}/>
                        <Route path="roles" component={AdminRoles}/>
                        <Route path="video" component={AdminVideoUpload}/>
                        <Route path="book/:bookId" component={AdminBook}/>
                        <Route path="book/:bookId/:chapterId" component={AdminBook}/>
                        <Route path="book/:bookId/:chapterId/:subchapterId" component={AdminExerciseList}/>
                        <Route path="book/:bookId/:chapterId/:subchapterId/:exerciseId" component={AdminExerciseList}/>
                        <Route path="import" onEnter={directToUniqueImportId}/>
                        <Route path="import/:importId" component={Import}/>
                    </Route>
                    <Route path="/" component={App}>
                        <Route path="login" component={Login}/>
                        <Route path="logout" onEnter={this.logout}/>
                        <Route path="signup" component={Signup}/>
                        <Route path="signup/profile" component={SignupProfile}/>
                        <Route path="signup/school" component={SignupSchool}/>
                        <Route path="signup/book" component={SignupBook}/>
                        <Route path="signup/done" component={SignupDone}/>
                        <Route component={UserAuth}>
                            <IndexRoute component={Dashboard}/>
                            <Route path="profile" component={Profile}/>
                            <Route path="profile/school" component={ProfileSchool}/>
                            <Route path="profile/password" component={ProfilePassword}/>
                            <Route path="profile/notifications" component={ProfileNotifications}/>
                            <Route path="profile/payment" component={ProfilePayment}/>
                            <Route path="profile/payment/card" component={ProfilePaymentCard}/>
                            <Route path="profile/payment/cancel" component={ProfilePaymentCancel}/>
                            <Route path="profile/book" component={ProfileBook}/>
                            <Route path="bookrouter" component={BookRouter}/>
                            <Route path="book/:bookId" component={Book}/>
                            <Route path="book/:bookId/chapters" component={ChapterList}/>
                            <Route path="assessment" component={BookList}/>
                            <Route path="assessment/:bookId/chapters" component={AssessmentChapters}/>
                            <Route path="assessment/:bookId/difficulty" component={AssessmentDifficulty}/>
                            <Route path="book/:bookId/:chapterId" component={SubChapterList}/>
                            <Route path="book/:bookId/:chapterId/:subchapterId/:exerciseId" component={Exercise}/>
                            <Route path="lesson" component={BookList}/>
                            <Route path="lesson/:lessonId" component={Lesson}/>
                            <Route path="lesson/:bookId/chapters" component={LessonChapters}/>
                            <Route path="lesson/:bookId/:chapterId" component={LessonSubChapters}/>
                            <Route path="mocks/page" component={Page}/>
                            <Route path="mocks/fileupload" component={FileUpload}/>
                            <Route path="support" component={Support}/>
                        </Route>
                        <Route path="*" component={NoMatch}/>
                    </Route>
                </Router>
            </UserRef>
        );
    }
});

export default Routes;


/** WEBPACK FOOTER **
 ** ./src/Routes.js
 **/